import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public IsMobile = Capacitor.getPlatform() !== 'web'

  public test: Date = new Date();

  /**
   * @constructor
   */
  constructor() {}

  /**
   * OnInit
   * @returns {void}
   */
  ngOnInit(): void { }

}
